// @ts-nocheck
import { produce, castDraft } from "immer";
import { type GetGroupListV2Query, type GetCachedGroupListV2Query } from "../queries";

export const GroupsQueryServiceV2 = {
    removeGroup(prevGroups: GetCachedGroupListV2Query, groupId: string): GetCachedGroupListV2Query {
        return produce(prevGroups, (draft: GetCachedGroupListV2Query) => {
            castDraft(draft.getGroupListV2).groupsWithConnections = castDraft(
                draft.getGroupListV2.groupsWithConnections.filter(({ group: { id } }) => id !== groupId),
            );
        });
    },

    addGroup(
        prevGroups: GetCachedGroupListV2Query,
        group: GetCachedGroupListV2Query["getGroupListV2"]["groupsWithConnections"][0],
    ): GetCachedGroupListV2Query {
        return produce(prevGroups, (draft: GetCachedGroupListV2Query) => {
            castDraft(draft.getGroupListV2.groupsWithConnections).unshift(castDraft(group));
        });
    },

    concat(prevGroups: GetGroupListV2Query, nextGroups: GetGroupListV2Query) {
        if (!nextGroups) {
            return prevGroups;
        }

        return produce(prevGroups, (draft: GetGroupListV2Query) => {
            castDraft(draft.getGroupListV2.groupsWithConnections).push(
                ...castDraft(nextGroups.getGroupListV2.groupsWithConnections),
            );
        });
    },
};
